export default __webpack_public_path__ + "static/media/prize-4.7fc51f3e.webp";